function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { useContext, useMemo } from 'react';
import { MapViewContext } from '../../../mapView/mapViewContext';
import text, { formatCurrency, formatSqmArea } from '../../../../text';
import { formatDate, formatMonth } from '../../../../utilities/date';
import { PRODUCT_TYPE, SALES_HELP_DISCOUNT } from '../../../../constants/product';
import { convertToGeoJson } from '../../../../utilities/map';
import { computeArea, computeUnion } from '../../../mapView/geometry';
import { isEmpty } from 'lodash';
import { roundToNearest } from '../../../../utilities/number';
import { DEFAULT_CURRENCY } from '../../../../constants/price';
import { useSelector } from 'react-redux';
import { isStaff, isUserGovernment, isUserUnderTrial, userHasValidMembership } from '../../../../utilities/user';
import { isMembershipPriceId } from '../../../../utilities/membership';
import { USER_TYPE } from '../../../../constants/user';
var SQM_IN_SQKM = 1e6;
export default function useProduct() {
    var _state_job_quote, _state_job;
    var state = useContext(MapViewContext).state;
    var _state_productSelected = state.productSelected, data = _state_productSelected.data, productType = _state_productSelected.product, isReadOnly = _state_productSelected.isReadOnly;
    var currency = ((_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_quote = _state_job.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.currency) || DEFAULT_CURRENCY;
    var _useSelector = useSelector(function(reduxState) {
        return {
            currentUser: reduxState.profileReducer.userProfile,
            membershipPriceId: reduxState.order.membershipPriceId
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    var product = useMemo(function() {
        if (data.length > 0) {
            return data[1][0];
        }
        return {};
    }, [
        data
    ]);
    var isEssentialUser = useMemo(function() {
        if (isUserGovernment(currentUser)) return true;
        return userHasValidMembership(currentUser) || isUserUnderTrial(currentUser);
    }, [
        currentUser
    ]);
    var selectionsPerProduct = useMemo(function() {
        var products = new Map();
        if (state.selections) {
            state.selections.forEach(function(selection) {
                if (products === null || products === void 0 ? void 0 : products[selection.category_name]) {
                    products[selection.category_name] = _to_consumable_array(products[selection.category_name]).concat([
                        selection
                    ]);
                } else {
                    products[selection.category_name] = [
                        selection
                    ];
                }
            });
        }
        return products;
    }, [
        state.selections
    ]);
    var charges = useMemo(function() {
        var _state_job_quote, _state_job;
        var products = new Map();
        if ((_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_quote = _state_job.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.charges) {
            state.job.quote.charges.forEach(function(charge) {
                products[charge.display_name] = _object_spread({}, charge);
            });
        }
        return products[product.display_name];
    }, [
        state.job,
        product
    ]);
    var age = useMemo(function() {
        if (!charges) {
            return;
        }
        var acquiredDates = charges.items.reduce(function(acc, next) {
            if (!next.details.acquired_at) {
                return []; // to avoid undefined
            }
            return _to_consumable_array(acc).concat([
                formatDate(next.details.acquired_at)
            ]);
        }, []);
        if (acquiredDates.length <= 0) {
            return;
        }
        var sortedAcquiredDates = Array.from(new Set(acquiredDates)).sort(function(a, b) {
            return new Date(a).getTime() - new Date(b).getTime();
        });
        var _ref = [
            sortedAcquiredDates[0],
            sortedAcquiredDates[sortedAcquiredDates.length - 1]
        ], startDate = _ref[0], endDate = _ref[1];
        if (startDate !== endDate) {
            return text('age', {
                dates: "".concat(formatMonth(startDate), " - ").concat(formatMonth(endDate))
            });
        }
        return text('age', {
            dates: formatMonth(startDate)
        });
    }, [
        charges
    ]);
    var totalArea = useMemo(function() {
        var _charges_details;
        if (!charges) {
            return {
                formatted: '',
                value: 0
            };
        }
        if (charges === null || charges === void 0 ? void 0 : (_charges_details = charges.details) === null || _charges_details === void 0 ? void 0 : _charges_details.area_in_sqm) {
            if (charges.details.area_in_sqm > SQM_IN_SQKM) {
                return {
                    formatted: "".concat((charges.details.area_in_sqm / SQM_IN_SQKM).toLocaleString(undefined, {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    }), " km\xb2"),
                    value: charges.details.area_in_sqm / SQM_IN_SQKM
                };
            }
            return {
                formatted: formatSqmArea(charges.details.area_in_sqm),
                value: charges.details.area_in_sqm
            };
        }
        return {
            formatted: '',
            value: 0
        };
    }, [
        charges
    ]);
    // Only calculate for Interior shapes union since
    // it's the only shape that computes area linearly
    // other shapes area is equal to union by default
    var shapesUnionArea = useMemo(function() {
        var _state_selections;
        if (![
            PRODUCT_TYPE.STREETSCAPE,
            PRODUCT_TYPE.INTERIOR,
            PRODUCT_TYPE.BIM_INTERIOR,
            PRODUCT_TYPE.TWOD_PLAN_INTERIOR
        ].includes(productType)) {
            return {
                formatted: '',
                value: 0
            };
        }
        var shapeCoordinates = convertToGeoJson((_state_selections = state.selections) === null || _state_selections === void 0 ? void 0 : _state_selections.filter(function(selection) {
            return selection.display_name === product.display_name;
        }));
        var unionCoordinates = _to_consumable_array(shapeCoordinates.features).reduce(function(prev, next) {
            if (!isEmpty(prev)) {
                return computeUnion(prev, next.geometry);
            }
            return next.geometry;
        }, {});
        var unionArea = !isEmpty(unionCoordinates) && computeArea(unionCoordinates);
        if (unionArea) {
            var diff = Math.abs(Math.floor(unionArea) - totalArea.value);
            unionArea = roundToNearest(unionArea, 1);
            if (diff <= 1) {
                // deny shape union if difference between area & union is <= 1,
                // this happens due to rouding off of area
                unionArea = 0;
            }
            if (unionArea > SQM_IN_SQKM) {
                return {
                    formatted: "".concat((unionArea / SQM_IN_SQKM).toLocaleString(undefined, {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    }), " km\xb2"),
                    value: unionArea / SQM_IN_SQKM
                };
            }
            return {
                formatted: unionArea > 0 ? formatSqmArea(unionArea) : '',
                value: unionArea
            };
        }
    }, [
        totalArea
    ]);
    var shapes = useMemo(function() {
        return selectionsPerProduct[productType];
    }, [
        selectionsPerProduct,
        productType
    ]);
    var price = useMemo(function() {
        if (!charges) {
            return {
                formatted: '',
                value: 0
            };
        }
        if (!charges || !charges.price) {
            return {
                formatted: text('notAvailable'),
                value: null
            };
        }
        if (!charges.price.total) {
            return {
                formatted: text('toBeConfirmed'),
                value: null
            };
        }
        var price = isEssentialUser ? charges.price.member_total : charges.price.total;
        return {
            formatted: formatCurrency(price, currency.name, currency.scale_factor, {}, true),
            value: price
        };
    }, [
        charges === null || charges === void 0 ? void 0 : charges.price,
        currency
    ]);
    var isFreeOrTrial = useMemo(function() {
        if (!charges) return;
        return !isMembershipPriceId(membershipPriceId) && !isStaff(currentUser.role);
    }, [
        charges === null || charges === void 0 ? void 0 : charges.price
    ]);
    var hasMemberDiscount = useMemo(function() {
        var _charges_price;
        if (!charges) return;
        return ((_charges_price = charges.price) === null || _charges_price === void 0 ? void 0 : _charges_price.member_discount_total) > 0;
    }, [
        charges === null || charges === void 0 ? void 0 : charges.price
    ]);
    var memberDiscount = useMemo(function() {
        var _charges_price;
        var totalAmount = charges ? charges.price.member_total : 0;
        var savingAmount = charges ? charges.price.member_discount_total : 0;
        var saving = formatCurrency(savingAmount, currency.name, currency.scale_factor, {}, true);
        if (!isEssentialUser || isStaff(currentUser.role)) {
            return text('memberPriceDiscount', {
                totalAmount: formatCurrency(totalAmount, currency.name, currency.scale_factor, {}, true),
                saving: saving
            });
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
            className: "text-strikethrough"
        }, text('fullPrice', {
            totalAmount: formatCurrency(charges === null || charges === void 0 ? void 0 : (_charges_price = charges.price) === null || _charges_price === void 0 ? void 0 : _charges_price.subtotal, currency.name, currency.scale_factor, {}, true)
        })), ', ', text('savingAmount', {
            saving: saving
        }));
    }, [
        isEssentialUser,
        charges === null || charges === void 0 ? void 0 : charges.price
    ]);
    var priceWithSalesHelp = useMemo(function() {
        if (!charges) {
            return {
                formatted: '',
                value: 0
            };
        }
        var userType = isEssentialUser ? USER_TYPE.ESSENTIALS : USER_TYPE.FREE;
        var salesHelpDiscount = SALES_HELP_DISCOUNT[productType][userType];
        if (salesHelpDiscount <= 0) {
            return text('notAvailable');
        }
        if (!charges || !charges.price) {
            return text('notAvailable');
        }
        if (!charges.price.total) {
            return text('toBeConfirmed');
        }
        var salesHelpSaving = charges.price.subtotal * (salesHelpDiscount / 100);
        return {
            total: formatCurrency(price.value + salesHelpSaving, currency.name, currency.scale_factor, {}, true),
            saved: formatCurrency(salesHelpSaving, currency.name, currency.scale_factor, {}, true),
            value: salesHelpSaving
        };
    }, [
        charges === null || charges === void 0 ? void 0 : charges.price,
        currency,
        productType
    ]);
    return {
        selectionsPerProduct: selectionsPerProduct,
        charges: charges,
        age: age,
        totalArea: totalArea,
        shapesUnionArea: shapesUnionArea,
        shapes: shapes,
        price: price,
        isEssentialUser: isEssentialUser,
        isFreeOrTrial: isFreeOrTrial,
        hasMemberDiscount: hasMemberDiscount,
        memberDiscount: memberDiscount,
        priceWithSalesHelp: priceWithSalesHelp,
        productType: productType,
        isReadOnly: isReadOnly,
        isStaff: isStaff(currentUser.role)
    };
}
